import { render, staticRenderFns } from "./CmhElectricityModifiedConnectionForm.vue?vue&type=template&id=172ff9bd"
import script from "./CmhElectricityModifiedConnectionForm.vue?vue&type=script&lang=ts"
export * from "./CmhElectricityModifiedConnectionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports